<div class="button-config-panel admin-theme" @fadeSlideInOut style="position: absolute;">

    <ng-container [ngSwitch]="config.type">
        <mat-form-field>
            <mat-label>Button-Aktion:</mat-label>
            <mat-select [(ngModel)]="config.type" (selectionChange)="onTypeChange()" panelClass="admin-theme">
                @for(actionType of actionTypes; track $index) {
                  <!-- TODO: SVI Currently, the action Navigate And Scroll cannot be configured in the frontend -->
                  @if (actionType !== ButtonActionType.NavigateAndScrollTo) {
                    <mat-option [value]="actionType">{{ displayNames[actionType] }}</mat-option>
                  }
                }
            </mat-select>
        </mat-form-field>

        <!-- ScrollTo -->
        @if (isScrollToParams(config.params)) {
        <mat-form-field *ngSwitchCase="ButtonActionType.ScrollTo">
          <mat-label>Ziel:</mat-label>
            <mat-select
            [(ngModel)]="config.params.target"
            (ngModelChange)="validateAndSave()"
            panelClass="admin-theme">
                @for(component of allCurrentComponents$(); track $index) {
                <mat-option [value]="component">
                    {{ component }}
                </mat-option>
            }
            </mat-select>
        </mat-form-field>
        }
      
        <!-- Navigate -->
        @if (isNavigateParams(config.params)) {
        <mat-form-field *ngSwitchCase="ButtonActionType.Navigate">
          <mat-label>Seitenname:</mat-label>
          <mat-select
            [(ngModel)]="config.params.url"
            (ngModelChange)="validateAndSave()"
            panelClass="admin-theme">
                @for(page of allPages$(); track $index) {
                <mat-option [value]="page.url">
                   {{ page.name }}
                </mat-option>
            }
          </mat-select>
        </mat-form-field>
        }
      </ng-container>
      
    <button (click)="close()">Schließen</button>
</div>